import { loggedIn } from '../../../routes/conditional';
import {
  clearUpdateOrderDeliveryAddressError,
  setDeliveryAddressOrderId,
  validateOrderDeliveryAddress,
} from '../../../redux/modules/orders';
import paths from '../../../routes/paths';
import { getPendingOrdersDeliveryPreferenceFlow } from '../../../redux/modules/root-reducer';

export const page = {
  path: '/orders/:orderId/change-delivery-address',
  isAllowed: [loggedIn],
  action: ({ params }) => setDeliveryAddressOrderId(params.orderId),
};

export const changeDeliveryAddress = {
  actionPath: '/actions/orders/change-delivery-address',
  inputLine1: 'line1',
  inputLine2: 'line2',
  inputCity: 'city',
  inputPostcode: 'postcode',
  inputOrderId: 'orderId',
  action: ({ body, state }) => {
    const flow = getPendingOrdersDeliveryPreferenceFlow(state);
    return validateOrderDeliveryAddress(
      body,
      flow,
      flow === 'checkout' ? paths.checkout.paymentDeliveryPreference : flow === 'checkoutMethod' ?  paths.checkout.paymentSummary : '/'
    );
  },
};

export const clearError = {
  actionPath: '/actions/orders/clear-update-delivery-address-error',
  action: () => clearUpdateOrderDeliveryAddressError(),
};
